/**
 * check localstorage for user's token and check if expired
 */
export const isLoggedIn = () => {
  const user = JSON.parse(localStorage.getItem('user') as string);
  if (!user) return false;
  if (!user.token) return false;
  return true;
};
